function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "dropdown_16"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  x: 0,
  y: 0,
  width: 16,
  height: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.45441699,3.69105066 C4.06285298,3.38487657 3.4972245,3.45409878 3.19105042,3.84566278 C2.88487633,4.23722679 2.95409854,4.80285527 3.34566254,5.10902935 L7.4423032,8.31229931 C7.76790887,8.56689886 8.22507288,8.56698878 8.55077868,8.31251736 L12.6507424,5.1092474 C13.0424269,4.80322739 13.1118716,4.23762619 12.8058516,3.84594176 C12.4998316,3.45425733 11.9342304,3.3848126 11.5425459,3.69083261 L7.99690513,6.46101434 L4.45441699,3.69105066 Z",
  id: "Mask",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var Svg16Down = function Svg16Down(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg16Down, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/16_down.3f4e72d3.svg";
export { ForwardRef as ReactComponent };